import React, { Component, useReducer } from 'react';
import {Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import Background_Image from '../images/image_3.jpg'
import { FaPaperPlane} from 'react-icons/fa'
import Room from './room';
import Image from '../images/live_page.png'

// 
if( /Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
  import('./live-mobile.css')
  .then((css) => {
     console.log('mobile');
  })
}else{
  import('./live-pc.css')
  .then((css) => {
     console.log('pc');
  })
}
//  
const { connect } = require('twilio-video')

class Live extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
          identity: '',
          room: null,
          session_name: '',
          access_token: '',
          status: '',
          request_by_session_author: null
      };

      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };

      this.LinkGoogleFit = () => {
        var redirect_uri = window.location.href
        var google_fit_client_id = '886472897374-s2u7n72g933iicbg45q2ofp22ptvc4fv.apps.googleusercontent.com';
        var google_fit_client_secret = 'qzq_z79ToXRnck0J4HzgOjSQ' ;
        
        var auth_prompt_uri = 'https://accounts.google.com/o/oauth2/v2/auth?scope=https://www.googleapis.com/auth/fitness.blood_glucose.read https://www.googleapis.com/auth/fitness.blood_pressure.read https://www.googleapis.com/auth/fitness.body_temperature.read https://www.googleapis.com/auth/fitness.body.read https://www.googleapis.com/auth/fitness.heart_rate.read https://www.googleapis.com/auth/fitness.oxygen_saturation.read https://www.googleapis.com/auth/fitness.sleep.read https://www.googleapis.com/auth/fitness.activity.read https://www.googleapis.com/auth/fitness.nutrition.read https://www.googleapis.com/auth/fitness.body.read&include_granted_scopes=true&response_type=token&redirect_uri=https://onfiit.com/live-session/&client_id=886472897374-s2u7n72g933iicbg45q2ofp22ptvc4fv.apps.googleusercontent.com'

        window.location.href = auth_prompt_uri
      }

      this.RenderTitle = () => {
        if(this.state.room == null){
          return<div>
            <br/>
            <h4 style={{color: '#20B8FF', fontWeight: 'bold'}}>
              Live Session
            </h4>
            <br/><br/>
          </div>
        }else{
          return<div></div>
        }
      }

      this.joinRoom = this.joinRoom.bind(this);
      this.returnToLobby = this.returnToLobby.bind(this);
      this.updateIdentity = this.updateIdentity.bind(this);
    }

    async joinRoom() {
        try {
          // const response = await fetch(`https://{your-endpoint}?identity=${this.state.identity}`);
          // const data = await response.json();
          const room = await connect(this.state.access_token, {
            name: this.state.session_name,
            audio: true,
            video: true
          });
      
          this.setState({ room: room });
        } catch(err) {
          console.log(err);
        }
    }

    returnToLobby() {
        this.setState({ room: null });
    }
      
    updateIdentity(event) {
        this.setState({
          identity: event.target.value
        });
    }
    
    componentDidMount() {
      var session_id = this.props.match.params.session_id

      const { cookies } = this.props;
      if(cookies.get('token')==null){
        let port = (window.location.port ? ':' + window.location.port : '');
        window.location.href = '//' + window.location.hostname + port + '/signin';
      };

      var data = new FormData()
      data.append('user_access_token', cookies.get('token'))
      data.append('session_id', session_id)

      axios.post(Backend_Url + 'verifyLive', data)
      .then((res) => {
          let result = res.data
          
          if(result == 'Live'){

            axios.post(Backend_Url + 'joinLive', data)
            .then((res) => {
                let result = res.data
                this.setState({
                  session_name: result.session_name, 
                  access_token: result.access_token, 
                  identity: result.user_name, 
                  request_by_session_author: result.request_by_session_author
                })
            }).catch((error) => {
                console.log(error)
            })

          }else if(result == 'Closed'){
            this.setState({status: 'ended'})
          }else if(result == 'Not found'){
            this.setState({status: 'not found'})
          }else{
            this.setState({status: 'error'})
          }
      }).catch((error) => {
          console.log(error)
      })

    }




    render() {
        var status = this.state.status
        if(status == 'ended'){
          return<Container>
            <Helmet>
              <title>LIVE SESSION- ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{backgroundColor: '#ffffff', opacity: 0.9, width: '100%', minHeight: '1000px'}}>
              <br/>
              <h4 style={{}}>
                Live Session
              </h4>
              <br/><br/>
              This live session has already been ended.
            </div>
          </Container>
        }else if(status == 'not found'){
          return<Container>
            <Helmet>
              <title>LIVE SESSION- ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{backgroundColor: '#ffffff', opacity: 0.9, width: '100%', minHeight: '1000px'}}>
              <br/>
              <h4 style={{}}>
                Live Session
              </h4>
              <br/><br/>
              This live session has not been found.
            </div>
          </Container>
        }else if(status == 'error'){
          return<Container>
            <Helmet>
              <title>LIVE SESSION- ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{backgroundColor: '#ffffff', opacity: 0.9, width: '100%', minHeight: '1000px'}}>
              <br/>
              <h4 style={{}}>
                Live Session
              </h4>
              <br/><br/>
              An error has occured, please reload.
            </div>
          </Container>
        }
        const disabled = this.state.identity === '' ? true : false;
        
      return (
        <div>
            <Helmet>
              <title>LIVE SESSION- ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{width: '100%', height: '630px', overflow: 'hidden'}}>
              <this.RenderTitle/>
              { 
                  this.state.room === null
                  ? <div>
                      <Row>
                        <Col>
                          You'll be joining as {this.state.identity}
                        </Col>
                      </Row>
                      <br/>
                      <Row>
                        <Col sm='6'>
                          <Button onClick={this.LinkGoogleFit} style={{border: 'none', backgroundColor: '#1faced', color: '#ffffff', width: '180px', borderRadius: '20px'}}>
                            Link Google Fit
                          </Button>
                          <br/>
                        </Col>
                        <Col sm='6'>
                          <Button disabled={disabled} onClick={this.joinRoom} style={{border: 'none', backgroundColor: '#1faced', color: '#ffffff', width: '180px', borderRadius: '20px'}}>
                            Join Session
                          </Button>
                        </Col>
                      </Row>
                      <br/><br/>
                      <img src={Image} style={{width: '30%'}} />
                  </div>
                  : <Room returnToLobby={this.returnToLobby} room={this.state.room} request_by_session_author={this.state.request_by_session_author} session_id={this.props.match.params.session_id}/>
              }
            </div>
        </div>
      );
    }

  };
  
  export default withCookies(Live);